import React, { useEffect } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Grid, Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import ContainerWithBackground from 'on_web/components/shared/Common/ContainerWithBackgroundImg';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import backgroundImg from 'on_web/assets/images/general-welcome-background.svg';
import Button from 'on_web/components/shared/Common/Button';
import { getAppRedirectRoute } from '../helpers/redirectHelper';
import useUsersApi from '../hooks/useUsersApi';

export default function PathSelectionPage(props) {
  const [{ response, loading, getUserData }] = useUsersApi();

  const useStyles = makeStyles(theme => ({
    root: {
      padding: 20,
      textAlign: 'center',
    },
    textHeading: { marginBottom: '32px' },
    button: {
      height: '42px',
      marginBottom: '20px',
      border: 'solid 3px #ffffff',
    },
    buttons: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      marginTop: '80px',
    },
  }));

  const classes = useStyles();

  const { t } = useTranslation();

  const buttonValues = [
    {
      path: 'spare',
      text: 'SPARE',
    },
    {
      path: 'xhealth',
      text: 'XHealth',
    },
    {
      path: 'pce',
      text: 'Precision Consumption',
    },
  ];

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  const onNavigate = path => {
    if (response && response.user_metadata) {
      let route = getAppRedirectRoute(path, response.user_metadata);
      props.history.push(route);
    }
  };

  return (
    <div>
      <Grid
        container={useMediaQuery('(min-width:1000px)')}
        direction="row"
        justify="center"
        alignItems="center"
      >
        {!loading && (
          <PageItemContainer>
            <ContainerWithBackground
              image={backgroundImg}
              maxWidth={'957px'}
              maxHeight={'830px'}
              height={'90vh'}
              width={'100vw'}
              marginTop={'0vh'}
            >
              <Box
                color="#ffffff"
                maxWidth="350px"
                position="relative"
                pr={{ xs: 2 }}
                pl={{ xs: 2 }}
                left={{ sm: '27%' }}
                top={{ sm: '10%', xs: '30%' }}
              >
                <Typography variant="h1" style={{ marginLeft: '10%' }}>
                  {t('pathSelection.titleText')}
                </Typography>

                <Box className={classes.buttons}>
                  {buttonValues.map((item, ix) => {
                    return (
                      <Button
                        key={ix}
                        className={classes.button}
                        fullWidth
                        onClick={() => onNavigate(item.path)}
                      >
                        {item.text}
                      </Button>
                    );
                  })}
                </Box>
              </Box>
            </ContainerWithBackground>
          </PageItemContainer>
        )}
      </Grid>
    </div>
  );
}
